<template>
  <v-layout row justify-end style="flex-wrap: nowrap;">
    <v-btn
      v-if="userCanRevoke"
      @click.stop="$emit('revoke')"
      x-small
      icon
      text
      color="accent"
      :class="{ 'edit-delete-button': visibilityHover }"
      class="ma-0 mr-2"
    >
      <v-icon>mdi-lock-open</v-icon>
    </v-btn>
    <v-btn
      v-if="isFloorbox && hasClosure"
      @click.stop="$emit('open-floorbox')"
      x-small
      icon
      text
      color="accent"
      :class="{ 'edit-delete-button': visibilityHover }"
      class="ma-0 mr-2"
    >
      <v-icon>mdi-open-in-app</v-icon>
    </v-btn>
    <v-btn
      v-if="userCanWorkspace"
      @click.stop="$emit('workspace')"
      x-small
      icon
      text
      color="accent"
      :class="{ 'edit-delete-button': visibilityHover }"
      class="ma-0 mr-2"
    >
      <v-icon>mdi-vector-arrange-below</v-icon>
    </v-btn>

    <v-btn
      v-if="userCanOpen"
      @click.stop="$emit('open')"
      x-small
      icon
      text
      color="accent"
      :class="{ 'edit-delete-button': visibilityHover }"
      class="ma-0 mr-2"
    >
      <v-icon>filter_none</v-icon>
    </v-btn>

    <v-btn
      v-if="userCanEdit"
      @click.stop="$emit('edit')"
      x-small
      icon
      text
      color="accent"
      :class="{ 'edit-delete-button': visibilityHover }"
      class="ma-0 mr-2"
    >
      <v-icon>edit</v-icon>
    </v-btn>

    <v-btn
      v-if="userCanDelete"
      @click.stop="$emit('delete')"
      x-small
      icon
      text
      color="accent"
      :class="{ 'edit-delete-button': visibilityHover }"
      class="ma-0 "
    >
      <v-icon>delete</v-icon>
    </v-btn>
  </v-layout>
</template>

<script>
export default {
  name: "AppDatatableActionButtons",

  props: {
    /**
     * Determines whether or not the user can edit the item
     */
    userCanEdit: {
      type: Boolean,
      required: false
    },

    /**
     * Determines whether or not the user can "open" the item
     */
    userCanOpen: {
      type: Boolean,
      default:false,
      required: false
    },

    /**
     * Determines whether or not the user can delete the item
     */
    userCanDelete: {
      type: Boolean,
      required: true
    },

    /**
     * Defines if icon is to be visible with or without hover
     */
    visibilityHover: {
      type: Boolean,
      default: true
    },

    /**
     * Determines whether or not the user can revoke the item
     */
    userCanRevoke: {
      type: Boolean,
      required: false
    },

    userCanWorkspace: {
      type: Boolean,
      required: false
    },
    /**
     * Determines if it is floorbox table
    */
    isFloorbox: {
      type: Boolean,
      default: false
    },
    hasClosure: {
      type:Boolean
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/_Molecules/AppDatatableActionButtons.vue